import PropTypes from 'prop-types'
import { gql } from '@apollo/client'
import {
  sharedEventDataFragment,
  sharedEventDataFragmentPropTypes,
} from '~/graphql/fragments/sharedEventData'
import money, { moneyPropTypes } from '~/graphql/fragments/money'
import externalPrimaryTicketShopFragment from './externalPrimaryTicketShop'

const eventTypeFragment = gql`
  fragment eventType on EventType {
    id
    slug
    title
    isSellingBlocked
    isRaffleEnabled
    startDate
    endDate
    availableTicketsCount
    soldTicketsCount
    ticketAlertsCount
    organizerProduct {
      id
      displayPrice {
        ...money
      }
    }
    ticketAlerts(first: 8) {
      edges {
        node {
          user {
            id
            avatar
          }
        }
      }
    }
    event {
      ...sharedEventData
      externalPrimaryTicketShops {
        ...externalPrimaryTicketShop
      }
    }
  }

  ${externalPrimaryTicketShopFragment}
  ${sharedEventDataFragment}
  ${money}
`

export default eventTypeFragment

export const eventTypeFragmentPropTypes = PropTypes.shape({
  id: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  isSellingBlocked: PropTypes.bool.isRequired,
  isRaffleEnabled: PropTypes.bool.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string,
  availableTicketsCount: PropTypes.number.isRequired,
  soldTicketsCount: PropTypes.number.isRequired,
  ticketAlertsCount: PropTypes.number.isRequired,
  organizerProduct: PropTypes.shape({
    id: PropTypes.string.isRequired,
    displayPrice: moneyPropTypes.isRequired,
  }),
  ticketAlerts: PropTypes.shape({
    edges: PropTypes.arrayOf(
      PropTypes.shape({
        node: PropTypes.shape({
          user: PropTypes.shape({
            id: PropTypes.string.isRequired,
            avatar: PropTypes.string,
          }),
        }),
      })
    ),
  }),
  event: PropTypes.shape({
    ...sharedEventDataFragmentPropTypes,
  }).isRequired,
})
